export default __webpack_public_path__ + "static/media/day_close.4b6c4419.svg";